<script>
   /*************************************************************/
   /* Widget for normalization                                  */
   /* -----------------------------------                       */
   /*************************************************************/

   import { Container, Select, RangeDiscrete } from 'svelte-controls-basic';
   import PrepTemplate from './PrepTemplate.svelte';

   let {
      params = $bindable([0, 0]),
      varind = $bindable(),
      settings = $bindable(),
      isOpen,
      left,
      right,
      nvars = 0,
      ...others
   } = $props();

   // prefix for the label ids the controls below are named by, unique per widget instance
   const uid = $props.id();

   // type to num maps
   const typesMap = {'snv': 0, 'area': 1, 'length': 2, 'var': 3};
   const types = Object.keys(typesMap);

   // the type shown is the parameter read back through the map and the variable index is the
   // parameter plus one; the controls write the parameters directly, so there is no copy of
   // them to keep in step
   const type = $derived(types[params[0]]);
   const varPos = $derived(params[1] + 1);

   // the positions a trim ahead of this method keeps, 1-based as the slider shows them
   const first = $derived(Number.isFinite(left) ? left + 1 : 1);
   const last = $derived(Number.isFinite(right) ? right : nvars);

   // an index from a saved chain, or one a trim moved or saved has left outside, is pulled in
   $effect(() => {
      if (type !== 'var' || last < first) return;
      if (params[1] + 1 < first) params[1] = first - 1;
      if (params[1] + 1 > last) params[1] = last - 1;
   });

   const title = 'Normalization';

   $effect(() => {
      settings = type + (type === 'var' ? ' #' + varPos : '');
   });

   // effect to mark the variable on the plot while the panel is open
   $effect(() => {
      if (type === 'var' && isOpen) {
         varind[0] = params[1];
      } else {
         varind[0] = -1;
      }
   });
</script>


<PrepTemplate {title} {settings} {isOpen} {...others}>
   <Container label="Type" id="{uid}-type">
   <Select bind:value={() => type, v => params[0] = typesMap[v]} options={types} />
   </Container>
   {#if type === 'var'}
   <Container label="Variable index" id="{uid}-varindex">
   <RangeDiscrete bind:value={() => varPos, v => params[1] = v - 1} min={first} max={last} step={1} />
   </Container>
   {/if}
</PrepTemplate>

